// Central place to describe subscription-gated features and labels.
export const subscriptionFeatures = {
  sms: {
    key: 'sms',
    label: 'SMS',
    priceLabel: '₹5',
    enabled: true,
    requiresSubscription: true,
  },
  call: {
    key: 'call',
    label: 'Calls',
    priceLabel: '₹5',
    enabled: true,
    requiresSubscription: true,
  },
  ai: {
    key: 'ai',
    label: 'AI Services',
    priceLabel: '₹5',
    enabled: true,
    requiresSubscription: true,
  },
  promptServices: {
    key: 'prompt-services',
    label: 'Prompt Services',
    priceLabel: '₹5',
    enabled: true,
    requiresSubscription: true,
  },
  imageGeneration: {
    key: 'image-generation',
    label: 'AI Image Generation',
    priceLabel: '₹5',
    enabled: true,
    requiresSubscription: true,
  },
};

export function getSubscriptionMeta(key) {
  return subscriptionFeatures[key] || { key, label: key, priceLabel: '₹5', unlockText: 'Unlock' };
}

export function isFeatureEnabled(key) {
  const meta = getSubscriptionMeta(key);
  return meta.enabled !== false;
}
